import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { FormControl, FormGroup, Col, ControlLabel, Button } from 'react-bootstrap';
import './styles.css';

const validate = values => {
  const errors = {};
  if (!values.firstname) {
    errors.firstname = 'Required';
  }
  if (!values.lastname) {
    errors.lastname = 'Required';
  }
  if (!values.username) {
    errors.username = 'Required';
  }
  if (!values.password) {
    errors.password = 'Required';
  }
  return errors;
};

const renderField = ({ feedbackIcon, input, label, type, meta: { touched, error, warning } }) => {
  const validationState = (touched && (error && 'error')) || (warning && 'warning') || null;
  return (
    <FormGroup controlId={input.name} validationState={validationState}>
      <Col componentClass={ControlLabel} xs={12} md={5} className="text-right">
        <div >
          <h4>
            {label}
            <span style={{ color: 'red' }}> *</span>
          </h4>
        </div>
      </Col>
      <Col xs={12} md={7}>
        <FormControl {...input} placeholder={label} type={type} />
        {feedbackIcon ? <FormControl.Feedback>{feedbackIcon}</FormControl.Feedback> : null}
        {touched &&
          ((error && <span className="help-block text-left">{error}</span>) ||
            (warning && <span className="help-block text-left">{warning}</span>))}
      </Col>
    </FormGroup>
  );
};

const UpdateUserForm = props => {
  const { handleSubmit, pristine, submitting, error } = props;
  return (
    <form onSubmit={handleSubmit} className="address-form">
      <h4>Create a New Account?</h4>
      <hr/>
      <Field name="firstname" type="text" component={renderField} label="First Name" />
      <Field name="lastname" type="text" component={renderField} label="Last Name" />
      <Field name="username" type="text" component={renderField} label="Username" />
      <Field name="password" type="password" component={renderField} label="Password" />
      <Button bsStyle="success" bsSize="large" type="submit" disabled={pristine || submitting}>
        <span>Create a New Account </span>{props.updateUserState.updateUserLoading ? <i className="fa fa-spinner fa-spin" /> : null}
      </Button>
      <div>{error && <strong style={{ color: 'red', marginLeft: '5px' }}>{error}</strong>}</div>
    </form>
  );
};

export default reduxForm({
  form: 'updateUser', // a unique identifier for this form
  validate // <--- validation function given to redux-form
  // warn // <--- warning function given to redux-form
})(UpdateUserForm);



// WEBPACK FOOTER //
// ./src/containers/CompleteBooking/PersonalDetails/form/index.js